import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {LazyLoadingData} from '../mapping-classes/lazy-loading-data';
import {ButtonData} from '../mapping-classes/button-data';
import {formatCurrency} from '@angular/common';
import {DetailScreen} from '../mapping-classes/detail-screen';

export class Debitcard implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;
  cardsResponse;

  private timeLimitOpts = {
    dag : 'Dag',
    week: 'Week',
    maand: 'Maand',
  };

  constructor(response: any) {
    this.title = 'Rabo WereldPas';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.cardsResponse = response.detailsViewObject;
      this.title = response.detailsViewObject.commercialProductTypeName || 'Rabo WereldPas';
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
      this.addButtons(response);
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];
      this.setNameAndValues(response);
    }
  }

  setNameAndValues(response?) {
    const cards = response.detailsViewObject;
    this.panels.push(new DetailPanel('Productkenmerken'));
    const productDetailsPanel: DetailPanel = this.panels[0];
    let nextPanelIndex;
    this.fillProductDetailsPanel(productDetailsPanel);
    this.addValuesToProductDetailsPanel(productDetailsPanel, cards);

    if ((cards.physicalCards && cards.physicalCards.length) ||
      (cards.requestedPhysicalCards && cards.requestedPhysicalCards.length)) {
      this.panels.push(new DetailPanel('Fysieke passen'));
      nextPanelIndex = this.panels.length - 1;

      const physicalCardsPanel: DetailPanel = this.panels[nextPanelIndex];
      this.addSubHeaderToPanel(physicalCardsPanel, 'Product afspraken');

      if (cards.physicalCards && cards.physicalCards.length) {
        this.addSubHeaderToPanel(physicalCardsPanel, 'Passen');
      }
      if (cards.requestedPhysicalCards && cards.requestedPhysicalCards.length) {
        this.addSubHeaderToPanel(physicalCardsPanel, 'Aanvragen passen / laatste PIN mailer');
      }

      this.fillPhysicalCardsPanel(physicalCardsPanel, response);
      this.addValuesToPhysicalCardsPanel(physicalCardsPanel, cards);
    }

    if ((cards.mobileCards && cards.mobileCards.length) ||
      (cards.requestedMobileCards && cards.requestedMobileCards.length)) {
      this.panels.push(new DetailPanel('Mobiele passen'));
      nextPanelIndex = this.panels.length - 1;
      const mobileCardsPanel: DetailPanel = this.panels[nextPanelIndex];
      this.addSubHeaderToPanel(mobileCardsPanel, 'Productafspraken');

      if (cards.mobileCards && cards.mobileCards.length) {
        this.addSubHeaderToPanel(mobileCardsPanel, 'Passen');
      }

      if (cards.requestedMobileCards && cards.requestedMobileCards.length) {
        this.addSubHeaderToPanel(mobileCardsPanel, 'Aanvragen');
      }
      this.fillMobileCardsPanel(mobileCardsPanel, response);
      this.addValuesToMobileCardsPanel(mobileCardsPanel, cards, nextPanelIndex);
    }
  }

  private addButtons(response) {
    this.buttons.push(new ButtonData('productservicesurl', response.detailsViewObject['arrangementNumber'],
      response.detailsViewObject['administrationCode'], response.detailsViewObject['commercialProductTypeCode'],
      'Productservice Fysiek', 'C'));

    this.buttons.push(new ButtonData('productservicesurl', response.detailsViewObject['arrangementNumber'],
      response.detailsViewObject['administrationCode'], response.detailsViewObject['commercialProductTypeCode'],
      'Productservice Mobiel', 'M'));
  }

  private createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('arrangementNumber', new DetailLabel('Overeenkomstnummer'));
    productDetailsPanel.nameAndValues.set('status', new DetailLabel('Status'));
    productDetailsPanel.nameAndValues.set('accountNumber', new DetailLabel('Rekeningnummer'));
    productDetailsPanel.nameAndValues.set('firstName', new DetailLabel('Naam 1'));
    productDetailsPanel.nameAndValues.set('secondName', new DetailLabel('Naam 2'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('arrangementNumber').setValue(obj.arrangementNumber);
    productDetailsPanel.nameAndValues.get('status').setValue(obj.status);
    productDetailsPanel.nameAndValues.get('accountNumber').setValue(obj.accountNumber);
    productDetailsPanel.nameAndValues.get('firstName').setValue(obj.firstName);
    productDetailsPanel.nameAndValues.get('secondName').setValue(obj.secondName);
  }

  private fillPhysicalCardsPanel(physicalCardsPanel: DetailPanel, response?) {
    const tempLimitAmountGea =
      `Limiet GEA per ${this.timeLimitOpts[response.detailsViewObject.cashDispenserLimitPeriodPhysical.toLowerCase()]}`;
    const tempLimitAmountBea =
      `Limiet BEA per ${this.timeLimitOpts[response.detailsViewObject.pointOfSaleTerminalLimitPeriodPhysical.toLowerCase()]}`;
    physicalCardsPanel.subPanels[0].nameAndValues
      .set('cashDispenserLimitAmountPhysical', new DetailLabel(tempLimitAmountGea));
    physicalCardsPanel.subPanels[0].nameAndValues.set('cashDispenserTemporaryLimitAmount', new DetailLabel('Tijdelijke limiet GEA'));
    physicalCardsPanel.subPanels[0].nameAndValues.set('cashDispenserTemporaryLimitStartDate', new DetailLabel('Geldig van'));
    physicalCardsPanel.subPanels[0].nameAndValues.set('cashDispenserTemporaryLimitEndDate', new DetailLabel('Geldig t/m'));
    physicalCardsPanel.subPanels[0].nameAndValues.set('cashDispenserRemainingAmountPhysical', new DetailLabel('Resterend bedrag GEA'));

    physicalCardsPanel.subPanels[0].nameAndValues.set('pointOfSaleTerminalLimitAmount', new DetailLabel(tempLimitAmountBea));
    physicalCardsPanel.subPanels[0].nameAndValues
      .set('pointOfSaleTemporaryLimitAmount', new DetailLabel('Tijdelijke limiet BEA'));
    physicalCardsPanel.subPanels[0].nameAndValues.set('pointOfSaleTemporaryLimitStartDate', new DetailLabel('Geldig van'));
    physicalCardsPanel.subPanels[0].nameAndValues.set('pointOfSaleTemporaryLimitEndDate', new DetailLabel('Geldig t/m'));
    physicalCardsPanel.subPanels[0].nameAndValues
      .set('pointOfSaleTerminalRemainingAmountPhysical', new DetailLabel('Resterend bedrag BEA'));

    physicalCardsPanel.subPanels[0].nameAndValues.set('contactlessPayment', new DetailLabel('Contactloos betalen'));
  }

  private fillMobileCardsPanel(mobileCardsPanel: DetailPanel, response?) {
    const tempLimitAmountBea =
      `Limiet BEA per ${this.timeLimitOpts[response.detailsViewObject.pointOfSaleTerminalLimitPeriodMobile.toLowerCase()]}`;
    mobileCardsPanel.subPanels[0].nameAndValues.set('pointOfSaleTerminalLimitAmount', new DetailLabel(tempLimitAmountBea));
  }

  private addValuesToPhysicalCardsPanel(physicalCardsPanel: DetailPanel, obj) {
    let cashDispenserTemporaryLimitAmount;
    let cashDispenserTempLimitStartDate;
    let cashDispenserTempLimitEndDate;
    let pointOfSaleTempLimitAmount;
    let pointOfSaleTermLimitStartDate;
    let pointOfSaleTermLimitEndDate;

    if (obj.physicalCards != null && obj.physicalCards.length) {
      if (obj.physicalCards[0].cashDispenserLimit) {
        cashDispenserTemporaryLimitAmount =
          formatCurrency(obj.physicalCards[0].cashDispenserLimit.temporaryLimitAmount, 'nl', '€') || '-';
        cashDispenserTempLimitStartDate = obj.physicalCards[0].cashDispenserLimit.temporaryLimitStartDate || '-';
        cashDispenserTempLimitEndDate = obj.physicalCards[0].cashDispenserLimit.temporaryLimitEndDate || '-';
      }

      if (obj.physicalCards[0].pointOfSaleTerminalLimit)  {

        pointOfSaleTempLimitAmount =
          formatCurrency(obj.physicalCards[0].pointOfSaleTerminalLimit.temporaryLimitAmount, 'nl' , '€') || '-';
        pointOfSaleTermLimitStartDate = obj.physicalCards[0].pointOfSaleTerminalLimit.temporaryLimitStartDate || '-';
        pointOfSaleTermLimitEndDate = obj.physicalCards[0].pointOfSaleTerminalLimit.temporaryLimitEndDate || '-';
      }

    } else if (obj.requestedPhysicalCards && obj.requestedPhysicalCards.length) {

      if (obj.requestedPhysicalCards[0].cashDispenserLimit) {
        cashDispenserTemporaryLimitAmount =
          formatCurrency(obj.requestedPhysicalCards[0].cashDispenserLimit.temporaryLimitAmount, 'nl', '€') || '-';
        cashDispenserTempLimitStartDate = obj.requestedPhysicalCards[0].cashDispenserLimit.temporaryLimitStartDate || '-';
        cashDispenserTempLimitEndDate = obj.requestedPhysicalCards[0].cashDispenserLimit.temporaryLimitEndDate || '-';
      }

      if (obj.requestedPhysicalCards[0].pointOfSaleTerminalLimit) {
        pointOfSaleTempLimitAmount =
          formatCurrency(obj.requestedPhysicalCards[0].pointOfSaleTerminalLimit.temporaryLimitAmount, 'nl' , '€') || '-';
        pointOfSaleTermLimitStartDate = obj.requestedPhysicalCards[0].pointOfSaleTerminalLimit.temporaryLimitStartDate || '-';
        pointOfSaleTermLimitEndDate = obj.requestedPhysicalCards[0].pointOfSaleTerminalLimit.temporaryLimitEndDate || '-';
      }
    }

    const contactlessPayment = obj.contactlessPayment ? 'Aan' : 'Uit';

    const cashDispenserLimitAmountPhysical = (obj.cashDispenserLimitAmountPhysical || obj.cashDispenserLimitAmountPhysical === 0) ?
      formatCurrency(obj.cashDispenserLimitAmountPhysical, 'nl', '€') : '-';
    const pointOfSaleTerminalRemainingAmountPhysical =
      (obj.pointOfSaleTerminalRemainingAmountPhysical || obj.pointOfSaleTerminalRemainingAmountPhysical === 0)  ?
        formatCurrency(obj.pointOfSaleTerminalRemainingAmountPhysical, 'nl', '€') : '-';
    const cashDispenserRemainingAmountPhysical =
      (obj.cashDispenserRemainingAmountPhysical || obj.cashDispenserRemainingAmountPhysical === 0) ?
        formatCurrency(obj.cashDispenserRemainingAmountPhysical, 'nl', '€') : '-';
    const pointOfSaleTerminalLimitAmount =
      (obj.pointOfSaleTerminalLimitAmountPhysical || obj.pointOfSaleTerminalLimitAmountPhysical === 0) ?
        formatCurrency(obj.pointOfSaleTerminalLimitAmountPhysical, 'nl', '€') : '-';

    physicalCardsPanel.subPanels[0].nameAndValues.get('cashDispenserLimitAmountPhysical').setValue(cashDispenserLimitAmountPhysical);
    physicalCardsPanel.subPanels[0].nameAndValues.get('cashDispenserTemporaryLimitAmount')
      .setValue(cashDispenserTemporaryLimitAmount || '-');
    physicalCardsPanel.subPanels[0].nameAndValues.get('cashDispenserTemporaryLimitStartDate').setValue(cashDispenserTempLimitStartDate);
    physicalCardsPanel.subPanels[0].nameAndValues.get('cashDispenserTemporaryLimitEndDate').setValue(cashDispenserTempLimitEndDate);

    physicalCardsPanel.subPanels[0].nameAndValues.get('cashDispenserRemainingAmountPhysical')
      .setValue(cashDispenserRemainingAmountPhysical);
    physicalCardsPanel.subPanels[0].nameAndValues.get('pointOfSaleTerminalLimitAmount')
      .setValue(pointOfSaleTerminalLimitAmount);
    physicalCardsPanel.subPanels[0].nameAndValues.get('pointOfSaleTemporaryLimitAmount')
      .setValue(pointOfSaleTempLimitAmount || '-');
    physicalCardsPanel.subPanels[0].nameAndValues.get('pointOfSaleTemporaryLimitStartDate')
      .setValue(pointOfSaleTermLimitStartDate);
    physicalCardsPanel.subPanels[0].nameAndValues.get('pointOfSaleTemporaryLimitEndDate')
      .setValue(pointOfSaleTermLimitEndDate);
    physicalCardsPanel.subPanels[0].nameAndValues.get('pointOfSaleTerminalRemainingAmountPhysical')
      .setValue(pointOfSaleTerminalRemainingAmountPhysical);
    physicalCardsPanel.subPanels[0].nameAndValues.get('contactlessPayment').setValue(contactlessPayment);

    if (obj.physicalCards && obj.physicalCards.length) {
      const physicalCardIndex = this.getPanelIndexByName('Passen');
      this.addTable(physicalCardsPanel, obj, 'physical', physicalCardIndex);
    }

    if (obj.requestedPhysicalCards && obj.requestedPhysicalCards.length) {
      const reqPhysicalCardIndex = this.getPanelIndexByName('Aanvragen passen / laatste PIN mailer');
      this.addTable(physicalCardsPanel, obj, 'requestedphysical', reqPhysicalCardIndex);
    }
  }

  private getPanelIndexByName(name: string): number {
    let physicalCardIndex;
    this.panels.forEach((panel: DetailPanel) => {
      if (panel.subPanels && panel.subPanels.length) {
        panel.subPanels.forEach((subPanel, key) => {
          if (subPanel.name === name) {
            physicalCardIndex = key;
          }
        });
      }
    });
    return physicalCardIndex;
  }

  private addValuesToMobileCardsPanel(mobileCardsPanel: DetailPanel, obj, index: number) {
    const pointOfSaleTerminalLimitAmountMobile =
      (obj.pointOfSaleTerminalLimitAmountMobile || obj.pointOfSaleTerminalLimitAmountMobile === 0) ?
        formatCurrency(obj.pointOfSaleTerminalLimitAmountMobile, 'nl', '€') : '-';

    mobileCardsPanel.subPanels[0].nameAndValues.get('pointOfSaleTerminalLimitAmount').setValue(pointOfSaleTerminalLimitAmountMobile);
    if (obj.mobileCards && obj.mobileCards.length) {
      const mobileCardsIndex = this.getPanelIndexByName('Passen');
      this.addTable(mobileCardsPanel, obj, 'mobile', mobileCardsIndex);
    }
    if (obj.requestedMobileCards && obj.requestedMobileCards.length) {
      const reqMobileCardSubPanelIndex = this.getPanelIndexByName('Aanvragen');
      this.addTable(mobileCardsPanel, obj, 'requestedmobile', reqMobileCardSubPanelIndex);
    }
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }

  private addTable(panel: DetailPanel, obj, table, index) {

    // tslint:disable-next-line:no-shadowed-variable
    const tables = ( table ): string => {
      const tablesType = {
        physical: 'physicalCards',
        requestedphysical: 'requestedPhysicalCards',
        mobile: 'mobileCards',
        requestedmobile: 'requestedMobileCards',
      };

      return tablesType[table];
    };

    panel.subPanels[index].hasTable = true;
    panel.subPanels[index].lazyLoadingData =
      new LazyLoadingData(null, null, table);

    if (obj[tables(table)] && obj[tables(table)].length !== 0) {
      obj[tables(table)].forEach((_table) => {
        _table.restrictedData = obj.restrictedData;
      });
      panel.subPanels[index].lazyLoadingData.data = obj[tables(table)];
    }
  }

}
